<template>
  <v-dialog
    v-model="showModal"
    dark
    transition="dialog-bottom-transition"
    :persistent="true"
    :width="livestreamStarted ? 250 : null"
  >
    <v-card color="grey darken-4" dark class="successModalCard">
      <div id="success_modal">
        <div class="successImage">
          <img src="@/assets/img/hybrid_settings/success-check.svg" />
        </div>
        <div class="successTitle">
          {{ $t("hybrid_settings.success_title") }}
        </div>

        <div class="livestreamSuccessText" v-if="livestreamStarted">
          {{ $t("hybrid_settings.livestream_now_premium") }}
        </div>
        <div
          class="shortInfoText"
          v-html="
            isPremium
              ? $t('hybrid_settings.next_livestream_premium_info')
              : $t('hybrid_settings.next_livestream_public_info')
          "
          v-else
        ></div>

        <div class="longInfoBulletGroup" v-if="showLongInfo">
          <div class="longInfoTitle">
            {{ $t("hybrid_settings.next_livestream_long_title") }}
          </div>
          <div class="longInfoBullet">
            <div class="longInfoIcon extraLine">
              <img src="@/assets/img/hybrid_settings/long-info-bullet-1.svg" />
            </div>
            <div class="longInfoText">
              {{ $t("hybrid_settings.next_livestream_long_text_1") }}
            </div>
          </div>
          <div class="longInfoBullet">
            <div class="longInfoIcon extraLine">
              <img src="@/assets/img/hybrid_settings/long-info-bullet-2.svg" />
            </div>
            <div class="longInfoText">
              {{ $t("hybrid_settings.next_livestream_long_text_2") }}
            </div>
          </div>
          <div class="longInfoBullet">
            <div class="longInfoIcon extraLine">
              <img
                src="@/assets/img/hybrid_settings/long-info-bullet-3@3x.webp"
              />
            </div>
            <div class="longInfoText">
              {{ $t("hybrid_settings.next_livestream_long_text_3") }}
            </div>
          </div>
          <div class="longInfoBullet">
            <div class="longInfoIcon">
              <img
                src="@/assets/img/hybrid_settings/long-info-bullet-4@3x.webp"
              />
            </div>
            <div class="longInfoText">
              {{ $t("hybrid_settings.next_livestream_long_text_4") }}
            </div>
          </div>
        </div>

        <div class="successButtonWrapper" v-if="!livestreamStarted">
          <div class="successButton" @click="doneButton()">
            {{ $t("hybrid_settings.done_button") }}
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
const { localStore, STORE_KEYS } = require("../../storage.js");

export default {
  name: "InviteModal",
  data() {
    return {
      showModal: false,
      showLongInfo: false,
    };
  },
  props: ["value", "livestreamStarted", "isPremium"],
  watch: {
    showModal: function (newVal) {
      this.$emit("input", newVal);
    },
    value: function (newVal) {
      this.showModal = newVal;
    },
    isPremium: function () {
      this.setsShowLongInfo();
    },
    livestreamStarted: function () {
      this.setsShowLongInfo();
    },
  },
  created() {
    this.setsShowLongInfo();
  },
  methods: {
    setsShowLongInfo() {
      this.showLongInfo = this.isPremium && !this.livestreamStarted;
      // localStore.getItem(STORE_KEYS.HYBRID_SETTINGS_LONG_INFO_SHOWN) == null;
    },
    doneButton() {
      if (this.showLongInfo) {
        localStore.setItem(
          STORE_KEYS.HYBRID_SETTINGS_LONG_INFO_SHOWN,
          new Date().toJSON()
        );
      }
      this.$emit("done");
    },
  },
};
</script>

<style lang="scss" scoped>
#success_modal {
  background: #171717;
  color: white;
  font-family: Avenir;
  user-select: none;
}

::v-deep .successModalCard {
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

.successImage {
  width: 100%;
  padding-top: 40px;
  display: flex;
  justify-content: center;
  img {
    width: 72px;
    height: 72px;
  }
}
.successTitle {
  width: 100%;
  font-family: Avenir-Heavy;
  font-size: 16px;
  text-align: center;
  padding: 12px 0 6px;
}

.livestreamSuccessText {
  width: 100%;
  font-family: Avenir;
  font-size: 14px;
  text-align: center;
  padding-bottom: 40px;
}

.shortInfoText {
  font-family: Avenir;
  width: 100%;
  padding: 0 26px 14px;
  padding: 0 calc((100% - 235px) / 2) 14px;
  text-align: center;
  font-size: 14px;
}

::v-deep .shortInfoText b {
  font-family: Avenir-Heavy;
}

.longInfoBulletGroup {
  width: 100%;
  padding: 0 20px 0;
  .longInfoTitle {
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
    font-size: 14px;
  }
  .longInfoBullet {
    width: 100%;
    display: flex;
    padding: 0 6px 6px;
    margin-top: -2px;
    overflow: hidden;
    .longInfoIcon {
      width: 56px;
      padding: 0 12px;
      position: relative;
      &.extraLine::after {
        content: "";
        position: absolute;
        left: 27px;
        top: 32px;
        width: 2px;
        height: 200px;
        background-color: #fff;
      }

      img {
        width: 32px;
        height: 32px;
      }
    }
    .longInfoText {
      flex: 1;

      font-size: 14px;
      padding-bottom: 6px;

      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}

.successButtonWrapper {
  width: 100%;
  padding: 14px 15px 24px;
  .successButton {
    font-family: Avenir-Heavy;
    font-size: 16px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border-radius: 22px;
    background-color: #0095ff;
  }
}
</style>
